import React from "react";
import { BaseLabel, BaseLabelRequired } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Label(_ref) {
  var content = _ref.content,
    htmlFor = _ref.htmlFor,
    required = _ref.required,
    hasError = _ref.hasError,
    id = _ref.id;
  return /*#__PURE__*/_jsxs(BaseLabel, {
    htmlFor: htmlFor,
    id: id,
    children: [content, required && /*#__PURE__*/_jsx(BaseLabelRequired, {
      hasError: hasError,
      children: "*"
    })]
  });
}
export default Label;